/**
 * The app-wide putt-distance ceiling.
 *
 * 60 ft is a PRODUCT/WARRANTY limit, not a measurement limit (Cole,
 * 2026-08-03): the gate reads faster putts fine, but a mode that asks for a
 * 70–80 ft lag is asking for a harder strike, and a ball striking the gate is
 * the thing that shifts the optics (see the FW 2.7.3 strike detector) and
 * generates warranty claims. So no game mode may offer — or, for contour,
 * PLAY LIKE — more than this.
 *
 * Every distance picker in the app reads its options from here. Before this
 * file the same table was copy-pasted into ten screens, which is exactly how
 * they drift apart.
 */
export const MAX_PUTT_DISTANCE_FT = 60;

/** Standard 5-ft-step picker used by challenge/friend/ladder/contour modes. */
export const PUTT_DISTANCE_OPTIONS: readonly number[] = [
  20, 25, 30, 35, 40, 45, 50, 55, 60,
];

/** Target mode's coarser fixed ladder (it starts shorter than the others). */
export const TARGET_FIXED_DISTANCES: readonly number[] = [15, 20, 25, 30, 35, 40, 50, 60];

/** Target random-range bounds. */
export const TARGET_RANDOM_MINS: readonly number[] = [15, 20, 25, 30];
export const TARGET_RANDOM_MAXES: readonly number[] = [30, 40, 50, 60];

/** True when a distance is inside the shipping ceiling. */
export function withinPuttCeiling(distanceFt: number): boolean {
  return Number.isFinite(distanceFt) && distanceFt <= MAX_PUTT_DISTANCE_FT;
}
